import React, {useState} from 'react';
// eslint-disable-next-line import/no-unresolved
import {Panel, PanelGroup, PanelResizeHandle} from 'react-resizable-panels';

import {cx} from '../util';

export {PanelGroup, Panel};

export const PanelResizer = ({direction = 'horizontal', className}) => {
  const [dragging, setDragging] = useState(false);

  return direction === 'horizontal' ? (
    <PanelResizeHandle className={cx('w-0.5 bg-white group relative', className)} onDragging={setDragging}>
      <div className={cx('mx-auto h-full group-hover:bg-indigo-600 group-hover:w-0.5 transition duration-100', {
        'w-px bg-gray-200': !dragging,
        'bg-indigo-600 w-0.5': dragging,
      })}
      />
      {/* Invisible spacer to increase click target */}
      <div className="absolute w-2 h-full bg-transparent top-0 left-1/2 -translate-x-1/2" />
    </PanelResizeHandle>
  ) : (
    <PanelResizeHandle className={cx('h-0.5 bg-white group relative', className)} onDragging={setDragging}>
      <div className={cx('my-auto w-full group-hover:bg-indigo-600 group-hover:h-0.5 transition duration-100', {
        'h-px bg-gray-200': !dragging,
        'bg-indigo-600 h-0.5': dragging,
      })}
      />
      {/* Invisible spacer to increase click target */}
      <div className="absolute h-2 w-full bg-transparent left-0 top-1/2 -translate-y-1/2" />
    </PanelResizeHandle>
  );
};
